export default __webpack_public_path__ + "static/media/gear.21b625dc.svg";